import {
  useCreatePublicQuoteReservationMutation,
  useGetPublicQuoteInfoMinimalQuery,
  useRequestPublicQuoteSimilarMutation,
} from '@massilia/queries'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'

import { similarRequestFor } from '@/components/estimates/similar-request'
import { LoadingSkeleton } from '@/routes/reservation/-components/loading-skeleton'
import { ReservationError } from '@/routes/reservation/-components/reservation-error'
import { ReservationForm } from '@/routes/reservation/-components/reservation-form'

const searchSchema = z.object({
  withInsurance: z.boolean().optional().default(false),
})

/**
 * Réservation depuis le lien public. Même formulaire que partout ailleurs,
 * derrière le jeton de la proposition.
 */
export const Route = createFileRoute('/_blue_header/devis_/$estimateResponseId_/reserver')({
  component: PublicReservationPage,
  errorComponent: ReservationError,
  validateSearch: searchSchema,
})

export function PublicReservationPage() {
  const { estimateResponseId } = Route.useParams()
  const { withInsurance } = useSearch({
    from: '/_blue_header/devis_/$estimateResponseId_/reserver',
  })
  const createReservation = useCreatePublicQuoteReservationMutation()
  const requestSimilar = useRequestPublicQuoteSimilarMutation()

  const {
    data: estimateData,
    error,
    isLoading,
  } = useGetPublicQuoteInfoMinimalQuery(estimateResponseId)

  if (isLoading) return <LoadingSkeleton />
  if (error || !estimateData) {
    return (
      <ReservationError
        error={error}
        requestSimilar={similarRequestFor(requestSimilar, estimateResponseId)}
      />
    )
  }

  return (
    <ReservationForm
      estimateData={estimateData}
      estimateResponseId={estimateResponseId}
      submit={async (request) =>
        createReservation.mutateAsync({ ...request, responseId: estimateResponseId })
      }
      withInsurance={withInsurance}
    />
  )
}
